'use client'
import { useCallback, useState } from 'react'
import {
  Home as HomeData,
  FeaturedProfiles as FeaturedProfilesData,
  FeaturedVideos as FeaturedVideosData,
} from '@/payload-types'
import HeroArea from '@/components/home-page/heroArea'
import FeaturedCampaigns, { IFeaturedCampaignsData } from './featuredCampaigns'
import Donate from '@/components/home-page/donate'
import FeaturedVideos from '@/components/home-page/featuredVideos'
import SearchSection from '@/components/home-page/searchSection'
import { ProfilesSection } from '@/components/home-page/ProfilesSection'
import { IBackgroundColor } from './ProfilesSection'
interface IProps {
  homePageData: HomeData
  campaignsData: IFeaturedCampaignsData[]
}
export const Home = ({ homePageData, campaignsData }: IProps) => {
  const [backgroundColor, setBackgroundColor] = useState<IBackgroundColor>({
    backgroundColor: campaignsData?.[0]?.data?.backgroundColor,
    darkBackgroundColor: campaignsData?.[0]?.data?.darkBackgroundColor,
  })
  const handleSelectedIndexChange = useCallback(
    (index: number) => {
      setBackgroundColor({
        backgroundColor: campaignsData?.[index]?.data?.backgroundColor,
        darkBackgroundColor: campaignsData?.[index]?.data?.darkBackgroundColor,
      })
    },
    [campaignsData],
  )
  return (
    <>
      <HeroArea />
      <FeaturedCampaigns
        campaignsData={campaignsData}
        onSelectedIndexChange={handleSelectedIndexChange}
        backgroundColor={backgroundColor}
      />
      <ProfilesSection
        featuredProfilesData={homePageData.featuredProfiles as FeaturedProfilesData}
        backgroundColor={backgroundColor}
      />
      <SearchSection />
      <hr className="lg:w-[60vw] w-[90vw] h-[1px] flex justify-self-center bg-gray-200 hidden sm:block" />
      <FeaturedVideos videos={homePageData.featuredVideos as FeaturedVideosData} />
      <Donate />
    </>
  )
}
export default Home
